import React from 'react'
import PatCSMobileWrapper from './mobile/components/PatCSMobileWrapper'

const PatCareSync = () => {
  return <PatCSMobileWrapper />
}

export default PatCareSync
